import React, { useState } from "react";
import { useL } from "@/lib/useL";
import { Eye, EyeOff } from "lucide-react";

// Password field with a show/hide eye button.
export function PasswordInput({ className = "", testid, ...props }) {
  const L = useL();
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input {...props} type={visible ? "text" : "password"} data-testid={testid} className={`${className} pr-12`} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? L("Masquer le mot de passe", "Hide password") : L("Afficher le mot de passe", "Show password")}
        data-tip={visible ? L("Masquer le mot de passe", "Hide password") : L("Afficher le mot de passe", "Show password")}
        data-testid={testid ? `${testid}-toggle` : undefined}
        className="absolute right-0 top-0 h-full px-4 text-muted-foreground hover:text-[#002FA7] transition-colors"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}

export default PasswordInput;
